import { render, staticRenderFns } from "./CzCard.vue?vue&type=template&id=1139e1fc&scoped=true&"
import script from "./CzCard.vue?vue&type=script&lang=ts&"
export * from "./CzCard.vue?vue&type=script&lang=ts&"
import style0 from "./CzCard.vue?vue&type=style&index=0&id=1139e1fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1139e1fc",
  null
  
)

export default component.exports